// export const SERVER_URI="https://adminapi.skyjumpertp.com/api/v1"


// export const SERVER_URI="http://3.110.163.114:3001/api/v1"

// export const SERVER_URI="http://20.197.49.59:3001/api/v1"

export const SERVER_URI="https://adminapi.skyjumpertp.com/api/v1"

// export const SERVER_URI="http://103.175.163.199:3001/api/v1"

export const SERVER_URI1="http://20.197.49.59:3004/api/pos/v1"

// export const SERVER_URI1="http://20.197.49.59:3004/api/pos/v1"

